// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-ui-ex-templates-template-js": () => import("/opt/build/repo/src/ui/@ex-templates/Template.js" /* webpackChunkName: "component---src-ui-ex-templates-template-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-animations-js": () => import("/opt/build/repo/src/pages/animations.js" /* webpackChunkName: "component---src-pages-animations-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("/opt/build/repo/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

